import { Component, Input } from '@angular/core';
import { IBotao } from '../../interfaces/ibotao';

@Component({
  selector: 'button[split-botao]',
  templateUrl: './botao.component.html',
  styleUrls: ['./botao.component.scss'],
})
export class BotaoComponent {
  @Input() botao: IBotao = {
    titulo: '',
    rota: '',
    rightIcon: '',
    leftIcon: '',
    estilo: '',
    disable: true,
    disableStyle: '',
  };
}
